import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';

import DatePicker from './DatePicker';
import { isBeforeMinimum } from '../../utils/validationHelpers';

// Same as datepicker, but only triggers onChange on valid date, or on blur
class DateInput extends Component {
  state = {
    isValid: true,
  };

  onDateChanged = val => {
    const { onChange } = this.props;
    if (!val) {
      this.setState({ isValid: false });
    } else {
      this.setState({ isValid: true });
      onChange(moment.utc(val));
    }
  };

  focusChanged = ({ focused }) => {
    if (!focused) {
      const { isValid } = this.state;
      const { onBlur } = this.props;
      if (!isValid) {
        // Will fall back to original value
        this.setState({ isValid: true, dateFocused: focused });
      } else {
        this.setState({ dateFocused: focused });
      }
      onBlur();
    } else {
      this.setState({ dateFocused: focused });
    }
  };

  render() {
    const { value, isOutsideRange, onChange, onBlur, ...rest } = this.props;
    const { isValid, dateFocused } = this.state;

    return (
      <DatePicker
        required
        block
        small
        {...rest}
        date={isValid ? value : null}
        onDateChange={this.onDateChanged}
        focused={dateFocused}
        onFocusChange={this.focusChanged}
        isOutsideRange={isOutsideRange}
      />
    );
  }
}
DateInput.propTypes = {
  value: momentPropTypes.momentObj,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  isOutsideRange: PropTypes.func,
};

DateInput.defaultProps = {
  value: moment.utc().startOf('day'),
  onBlur: () => {},
  isOutsideRange: isBeforeMinimum,
};
export default DateInput;
